import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronLeftSmallFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M19 10a9 9 0 1 0-18 0 9 9 0 0 0 18 0Zm-7.24-2.7a.75.75 0 1 0-1.02-1.1l-3.5 3.25a.75.75 0 0 0 0 1.1l3.5 3.25a.75.75 0 1 0 1.02-1.1L8.852 10l2.908-2.7Z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgChevronLeftSmallFill);
export { ForwardRef as ReactComponent };
